export default __webpack_public_path__ + "static/media/food-for-animal-welfare-vegshelf.edcb9b23.png";